import * as Utils from '../utils'
import Store from '../store/index'

function validaCard(cardNumber){
        cardNumber = cardNumber.replace(/[^0-9]/g, '');


        if (cardNumber.length > 12) {
          let digit1 = cardNumber.substring(0, 1);
          let digit2 = cardNumber.substring(0, 2);
          let digit3 = cardNumber.substring(0, 3);
          let digit4 = cardNumber.substring(0, 4);
            /*
             * ----* VISA prefix=4* ---- length=13 or 16 (can be 15 too!?!
             * maybe)
             */
            if (digit1 == 4) {
                if (cardNumber.length == 13 || cardNumber.length == 16)
                    return true;
            }
            /*
             * ----------* MASTERCARD prefix= 51 ... 55* ---------- length= 16
             */
            else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
                if (cardNumber.length == 16)
                    return true;
            }

            //  * ----* AMEX prefix=34 or 37* ---- length=15
            else if (digit2 == 34 || digit2 == 37) {
              if (cardNumber.length >= 15)
                return true;
            }

            /*
             * -----* ENROU prefix=2014 or 2149* ----- length=15
            else if (digit4 == 2014 || digit4 == 2149) {
                if (cardNumber.length == 15)
                    valid = "EN_ROUTE";
            }
             */
            /*
             * -----* DCLUB prefix=300 ... 305 or 36 or 38* ----- length=14
             */
            else if (digit2 == 36 || digit2 == 38 || (digit3 >= 300 && digit3 <= 305)) {
              if (cardNumber.length >= 15)
              return true;
            }
        }
        return false;
}

function isBrandValid(cardNumber){
  let brand = Utils.getCardBrand(cardNumber);
  
  return !!Store.getters.getPaymentsMethodsByPlan(Store.state.sales.currentPlanId).find(o => o.name == brand);
}

export const card = {
  messages: {
    en: (field, args) => {
      return "Cartão de crédito inválido!";
    },
    'pt-BR': (field, args) => {
      return "Cartão de crédito inválido!";
    }
  },
  validate(value) {
    return validaCard(value);
  }
};

export const brand = {
  messages: {
    en: (field, args) => {
      return "Bandeira não aceita!";
    },
    'pt-BR': (field, args) => {
      return "Bandeira não aceita!";
    }
  },
  validate(value) {
    return isBrandValid(value);
  }
};



// WEBPACK FOOTER //
// ./src/validators/card.js